export enum ReadingStatus {
  Normal = 'normal',
  Risk = 'risk',
  Critical = 'critical',
}

export enum OverviewDashboardStatus {
  Priority = 'priority',
  Critical = 'critical',
  Risk = 'risk',
  Normal = 'normal',
}
